import { render, staticRenderFns } from "./RawMaterialPriceList.vue?vue&type=template&id=a653e574&scoped=true&"
import script from "./RawMaterialPriceList.vue?vue&type=script&lang=js&"
export * from "./RawMaterialPriceList.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialPriceList.vue?vue&type=style&index=0&id=a653e574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a653e574",
  null
  
)

export default component.exports